// The submission's own origin id, so a key we read matches the one written for
// the submission we sent. Deliberately has no fallback: a substituted value
// would build a key nothing ever wrote.
export const getOriginId = () => process.env.NEXT_PUBLIC_SUBMISSION_ORIGIN_ID;

export const getCompositeSubmissionId = (submissionId) =>
  `${submissionId}:${getOriginId()}`;
